<div class="adhoc-report-container">
  <ptg-breadcrumb [listBreadcrumbs]="listBreadcrumbs"></ptg-breadcrumb>
  <div class="adhoc-report-section p-6">
    <div class="pb-6" *ngIf="bannerType">
        <ptg-banner
          [(bannerType)]="bannerType"
          [message]="message"
        ></ptg-banner>
    </div>
    <div class="flex gap-2">
      <ptg-button classInput="primary" buttonName="Generate Report" class="generate-button" (click)="onGenerateReport()">
      </ptg-button>
      <ptg-button *ngIf="templateId" classInput="primary" buttonName="Generate & Save Template" class="generate-button"
      (click)="onSaveTemplate(false)">
      </ptg-button>
      <ptg-button classInput="primary" buttonName="Generate & Save As New Template" class="generate-button"
        (click)="onSaveTemplate(true)"
      >
      </ptg-button>
      <ptg-button class="cancel-button" buttonName="Cancel" (click)="onCancel()">
      </ptg-button>
    </div>
    <div class="flex-grow overflow-hidden box-bordering mt-8">
      <div class="header">
        <span class="title font-bold">Report General Information</span>
      </div>
      <hr />
      <div class="flex flex-col column-filter pt-4">
        <div class="grid grid-cols-12 gap-x-4">
          <div class="col-span-12 flex gap-x-4">
            <ptg-textbox [class]="'w-[600px]'" [placeholder]="templateNamePlaceHolder" [maxLength]="150" class="template-name"
              [hasLabel]="true" [controlField]="templateNameCtrl" customError="templateNameExists"></ptg-textbox>
            <ptg-textbox [class]="'w-[600px]'" placeholder="Report Name" [maxLength]="150" class="report-name"
              [hasLabel]="true" [controlField]="reportNameCtrl"></ptg-textbox>
          </div>
          <div class="col-span-12">

          </div>
          <div class="col-span-12 col-start-1">
            <ptg-select [class]="'w-[600px]'" [controlField]="generateReportForCtrl" [isOptionObj]="true"
              [listData]="generateReportFor" [placeholder]="'Generate Report for'"
              (changeOptionValue)="onGenerateReportForChange($event)"></ptg-select>
          </div>
          <div class="col-span-12">
            <ptg-chip-selection [width]="'500px'" [inputType]="ChipInputType.Selection"
              [controlField]="filterDropdownCtrl" [placeholder]="filterDropdownName"
              [options]="filterDropdownOptions" [selectedOptionsTemplate]="selectedRowFilterOptions"
              (valueChange)="onChangeChipSelection($event)" [isSetMaxWidthSelect]="false" ></ptg-chip-selection>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-grow overflow-hidden box-bordering mt-6">
      <div class="header">
        <span class="title font-bold">Column Filter to Apply</span>
      </div>
      <hr />
      <div class="mt-6 mb-6">
        <ptg-card-filters [cardFilters]="selectedFilters" [canRemove]="true" (removed)="onRemoveFilter($event)">
        </ptg-card-filters>
      </div>

    </div>
    <div class="flex-grow overflow-hidden mt-6">
      <div class="flex overflow-hidden gap-4 items-start">
        <div class="pt-4 w-[33%] box-bordering">
          <div class="flex flex-col gap-2">
            <div class="header">
              <span class="title font-bold">Add Column</span>
            </div>
            <hr />
            <div class="flex flex-col">
            <div class="column-filter pt-4">
              <ptg-select [class]="'w-full'" [controlField]="cardSelectionCtrl" [isOptionObj]="true"
                [listData]="cardSelectionOptions" [placeholder]="'Card'"
                (changeOptionValue)="onCardSelectionChange($event)"
                [hasNoneValue]="true"></ptg-select>
            </div>
            <div class="column-filter" *ngIf="cardFilters && cardFilters.length > 0">
              <div *ngFor="let filter of cardFilters; let i = index; trackBy: trackByFilterId"
                >
                <ptg-select *ngIf="filter.configs.componentType === componentType.dropdown"
                  [class]="'w-full'" [controlField]="getFilterControl(filter)"
                  [listData]="getCachedFilterOptions(filter)" [placeholder]="filter.propertyName"
                  (changeOptionValue)="onFilterChange(filter, i, $event)" [isOptionObj]="true"
                  ></ptg-select>
                  <ptg-datepicker *ngIf="filter.configs.componentType === componentType.datepicker"
                    [controlField]="getFilterControl(filter)"
                    [placeholder]="filter.propertyName" 
                    [class]="'w-full'"
                    customError="dateRangeInvalid"
                    (changeValue)="onFilterChange(filter, i, $event)"
                  ></ptg-datepicker>
              </div>
            </div>
            <div class="column-filter">
              <ptg-select [class]="'w-full'" [controlField]="propertyCtrl" [isOptionObj]="true"
                [listData]="availablePropertyOptions" [placeholder]="'Property Name'"
                (changeOptionValue)="onPropertyChange($event)" [isMultipleLineOption]="true"></ptg-select>
            </div>
            <div class="column-filter" *ngIf="propertyOptions?.length">
              <ptg-radio-button [controlField]="dynamicFormGroup.get('option')"
                [listOption]="$any(propertyOptions)" [isObject]="true"></ptg-radio-button>
            </div>
            <div class="column-filter">
              <ptg-textbox [class]="'w-full'" placeholder="Column Name" [maxLength]="150" class="report-name"
                [hasLabel]="true" [controlField]="columnNameCtrl" customError="existed"></ptg-textbox>
            </div>
            <div class="column-filter pb-4">
              <ptg-button [buttonName]="'Add Column'" classInput="add-button" type="button"
                (clickButton)="addColumn()">
                <mat-icon>add</mat-icon>
              </ptg-button>
            </div>
            </div>
          </div>
        </div>
        <div class="pt-4 w-[33%] box-bordering">
          <div class="flex flex-col gap-2">
            <div class="header">
              <span class="title font-bold" [ngClass]="{
                  'no-data':
                  !sortPropertySectionDataTable ||
                  sortPropertySectionDataTable.length === 0
                }">Order Columns</span>
            </div>
            <ptg-grid #sortPropertyTable [data]="sortPropertySectionDataTable" [columns]="orderColumns"
              [notFoundMessage]="''" [isLoading]="isLoading" [fitToParent]="true" [paginable]="false"
              [allowDragDrop]="true" [hideHeader]="true" [inlineEditable]="true" [hardDeletable]="true"
              (hardDelete)="onRowActions({ row: $event, type: ACTION.REMOVE_PROPERTY_ROW })"
              (rowDrop)="changeItem($event, true)" [allowSaveInline]="true" (saveInlineValue)="onSaveColumnName($event)">
              <ng-template cellContent [columnName]="'columnName'" let-row>
                <ng-container>
                  <div class="multiple-line-text">
                    <span class="caption">{{ row.columnName }}</span>
                    <span class="description" 
                          [overflowTooltip]="row.columnNameDescription"
                          [matTooltip]="row.columnNameDescription"
                          matTooltipPosition="right"
                          >{{ row.columnNameDescription }}</span>    
                  </div>
                </ng-container>
              </ng-template>
              <ng-template cellContent [columnName]="ACTION_COLUMN" let-row>
                <ng-container *ngIf="!row.editing">
                  <ptg-button *ngIf="!row.deleted && !row.isUsed && row.columnName !== 'Note'"
                    (clickButton)="onRowActions({row, type: ACTION.ADD_SORT_ROW})" classInput="edit-button">
                    <mat-icon>arrow_right_alt</mat-icon>
                  </ptg-button>
                </ng-container>


              </ng-template>
            </ptg-grid>
          </div>
        </div>
        <div class="pt-4 w-[33%] box-bordering">
          <div class="flex flex-col gap-2">
            <div class="header">
              <span class="title font-bold" [ngClass]="{
            'no-data':
              !sortRowSectionDataTable || sortRowSectionDataTable.length === 0
          }">
                Sort Rows
              </span>
              </div>
              <ptg-grid #sortRowTable [data]="sortRowSectionDataTable" [columns]="sortColumns" [notFoundMessage]="''"
                [isLoading]="isLoading" [fitToParent]="true" [paginable]="false" [allowDragDrop]="true"
                [hideHeader]="true" (rowDrop)="changeItem($event)">
                <ng-template cellContent [columnName]="'columnName'" let-row>
                  <ng-container>
                    <div class="multiple-line-text">
                      <span class="caption">{{ row.columnName }}</span>
                         <span class="description" 
                          [overflowTooltip]="row.columnNameDescription"
                          [matTooltip]="row.columnNameDescription"
                          matTooltipPosition="right"
                          >{{ row.columnNameDescription }}</span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template cellContent [columnName]="ACTION_COLUMN" let-row>
                  <ng-container>
                    <ptg-button *ngIf="!row.deleted" (clickButton)="onRowActions({row, type: ACTION.SORT_CHANGE})"
                      classInput="edit-button">
                      <mat-icon>{{
                        row.sortType ? "arrow_downward" : "arrow_upward"
                        }}</mat-icon>
                    </ptg-button>
                  </ng-container>
                  <ng-container>
                    <ptg-button *ngIf="!row.deleted" classInput="delete-button"
                      (clickButton)="onRowActions({row, type: ACTION.REMOVE_SORT_ROW})">
                      <mat-icon>delete_forever</mat-icon>
                    </ptg-button>
                  </ng-container>
                </ng-template>
              </ptg-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>